import React, { useState } from "react";
import axios from "axios";
import RenderLabel from "./componet/RenderLabel";

function App() {
  const [model, setModel] = useState("");
  const [qty, setQty] = useState("");
  const [loading, setLoading] = useState(false);
  const [showQtyHint, setShowQtyHint] = useState(false);
  const [page, setPage] = useState(0);

  const generatePDF = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        "/create-pdf",
        { model, qty },
        {
          headers: { "Content-Type": "application/json" },
          responseType: "blob",
        }
      );
      // Blob으로 다운로드 트리거
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.download = `${model || "label"}_${qty || ""}.pdf`;
      a.href = url;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      alert("❌ PDF 생성 실패");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div style={{ padding: "50px", fontFamily: "Arial, sans-serif" }}>
      <h1 style={{ marginBottom: "20px" }}>
        📦 MEMPro 라벨 생성기 <span style={{ fontSize: "15px" }}>V1.1</span>
      </h1>
      <div style={{ fontSize: "12px", marginBottom: "20px" }}>
        <span> *스티커 용지 3203번 전용입니다.</span>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "10px",
          width: "210mm",
        }}
      >
        <div style={{ width: "80mm" }}>
          <label
            style={{ width: "50px", fontSize: "14px", fontWeight: "bold" }}
          >
            Model
          </label>
          <input
            placeholder="Model"
            value={model}
            onChange={(e) => setModel(e.target.value)}
            style={{
              padding: "8px",
              width: "200px",
              marginRight: "20px",
              marginLeft: "8px",
            }}
          />
        </div>
        <div
          style={{
            position: "relative",
            display: "inline-block",
            width: "80mm",
          }}
        >
          <label
            style={{ width: "50px", fontSize: "14px", fontWeight: "bold" }}
          >
            Qty
          </label>
          <input
            type="number"
            placeholder="Qty"
            value={qty}
            onChange={(e) => setQty(e.target.value)}
            onFocus={() => setShowQtyHint(true)}
            onBlur={() => setShowQtyHint(false)}
            style={{
              padding: "8px",
              width: "200px",
              position: "relative",
              marginLeft: "8px",
            }}
          />
          {showQtyHint && (
            <div
              style={{
                position: "absolute",
                backgroundColor: "#fff",
                border: "1px solid #ddd",
                borderRadius: "10px",
                padding: "6px 10px",
                fontSize: "12px",
                color: "#333",
                boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                marginTop: "4px",
                marginLeft: "30px",
                zIndex: 10,
                whiteSpace: "nowrap",
              }}
            >
              숫자만 입력하세요
              <div
                style={{
                  position: "absolute",
                  top: "-6px",
                  left: "10px",
                  width: 0,
                  height: 0,
                  borderLeft: "6px solid transparent",
                  borderRight: "6px solid transparent",
                  borderBottom: "6px solid #ddd",
                }}
              />
            </div>
          )}
        </div>
        <button
          onClick={generatePDF}
          disabled={loading}
          style={{
            padding: "10px 24px",
            backgroundColor: loading ? "#A0AEC0" : "#3182CE",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            fontSize: "14px",
            fontWeight: "bold",
            cursor: loading ? "not-allowed" : "pointer",
            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
            transition: "all 0.2s",
            marginLeft: "30px",
          }}
        >
          {loading ? "생성 중..." : "PDF 생성"}
        </button>
      </div>

      <div
        style={{
          marginTop: "30px",
          padding: "9mm 5mm",
          border: "1px dashed gray",
          width: "210mm",
          height: "297mm",
          backgroundColor: "#f9f9f9",
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      >
        <h3>📄 페이지 {page + 1}</h3>
        {Array.from({ length: parseInt(qty) * 2 || 0 })
          .slice(page * 3, page * 3 + 3)
          .flatMap((_, i) => {
            const labelNo = Math.floor((page * 3 + i) / 2) + 1;
            return (
              <RenderLabel
                key={page * 3 + i}
                model={model || "-"}
                number={labelNo}
                total={qty || "-"}
              />
            );
          })}
      </div>
      <div
        style={{
          marginTop: "10px",
          display: "flex",
          justifyContent: "center",
          gap: "10px",
          alignItems: "center",
          width: "210mm",
        }}
      >
        {parseInt(qty) * 2 > 3 && (
          <>
            <button
              onClick={() => setPage(Math.max(0, page - 1))}
              disabled={page === 0}
              style={{
                padding: "6px 16px",
                backgroundColor: "#E2E8F0",
                border: "1px solid #CBD5E0",
                borderRadius: "5px",
                fontSize: "13px",
                cursor: "pointer",
                transition: "background-color 0.2s",
                fontWeight: "bold",
              }}
            >
              ◀ 이전
            </button>
            <span style={{ fontWeight: "bold" }}>
              {page + 1} / {Math.ceil((parseInt(qty) * 2) / 3)}
            </span>
            <button
              onClick={() =>
                setPage(
                  Math.min(Math.ceil((parseInt(qty) * 2) / 3) - 1, page + 1)
                )
              }
              disabled={page >= Math.ceil((parseInt(qty) * 2) / 3) - 1}
              style={{
                padding: "6px 16px",
                backgroundColor: "#E2E8F0",
                border: "1px solid #CBD5E0",
                borderRadius: "5px",
                fontSize: "13px",
                cursor: "pointer",
                transition: "background-color 0.2s",
                fontWeight: "bold",
              }}
            >
              다음 ▶
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default App;
